/**
 * Rule to check if the field contains a value
 */
export default {
    name     : 'function',
    validate : (value) => value instanceof Function,
    message: field => `The field ${field} must be a function`
}